import CertificateItemModule from './certificate-item.module'

export default CertificateItemModule
